import Profile from 'common/domain/models/profile';
import vacationsAbsencesUser from 'common/domain/models/vacationsAbsencesUser';
import ERRORS from 'common/errors/formatter.errors';
import catchAndThrow from 'common/errors/error.utils';
import formatters from 'common/utils/periods.formatters';

function assembleProfile(data) {
  let profile = new Profile();
  profile.name = data.name;
  profile.email = data.email;
  profile.userId = data.enrolment;
  if (data.manager) {
    profile.role = Profile.ROLE_MANAGER;
  }
  if (data.bbvaUserId) {
    profile.bbvaUserId = data.bbvaUserId;
  }

  if (data.delegations && data.delegations.hasDelegation) {
    profile.delegation = data.delegations.hasDelegation;
  }

  return profile;
}

class employeeDataAssembler {
  static assemble(userId, data) {
    let profile;
    catchAndThrow(() => { profile = assembleProfile(data.profile); }, ERRORS.ASSEMBLE_PROFILE);
    let user = new vacationsAbsencesUser(userId, profile);
    user.absenceTypes = data.absenceTypes || [];
    user.dischargeReasons = data.dischargeReasons || [];
    user.vacationTypes = data.vacationTypes || [];
    user.vacationPeriods = data.vacationPeriods || [];
    user.absencePeriods = data.absencePeriods || [];
    user.maternityPaternityLeavePeriods = data.maternityPaternityLeavePeriods || [];
    user.nationalHolidays = data.nationalHolidays || [];
    user.localHolidays = data.localHolidays || [];
    user.holidays = formatters.formatHolidays(user.nationalHolidays, user.localHolidays);
    user.allPeriods = formatters.formatAllPeriods(user.absencePeriods, user.vacationPeriods, user.holidays);
    user.availableVacations = formatters.formatAvailableVacations(data.summaryAvailableVacations);
    user.periodInDays = formatters.formatPeriodInDays(user.allPeriods);
    return user;
  }
}

export default employeeDataAssembler;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/employeeRepository/employeeRepository.assemblers.js